import { render } from "./MemberRegistration.vue?vue&type=template&id=cc882fe2&ts=true"
import script from "./MemberRegistration.vue?vue&type=script&lang=ts"
export * from "./MemberRegistration.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__